import { BORDER_COLORS, SURFACE_COLORS, TEXT_COLORS } from '@constants/colors.ts';
import { FONT_FAMILY } from '@constants/fonts.ts';
import { BODY_MD_MD_STYLES, BODY_SM_SM_STYLES } from '@constants/text.ts';
import styled, { css } from 'styled-components';

const DEFAULT_SCROLL_STYLING_FOR_FILTERS = css`
    max-height: 164px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: ${BORDER_COLORS.focus} transparent;
`;

export const antdTableFilterStyles = css`
    /* for filter icon when filters applied on column */
    .ant-table-filter-trigger.active {
        svg path {
            stroke: ${SURFACE_COLORS.action};
        }
    }

    /* highlight filter icon when filter menu opened */
    .ant-table-filter-trigger.ant-dropdown-open {
        border-radius: var(--border-radius-xs_4, 4px);
        border: 2px solid var(--colors-border-focus, #2171c6);
    }

    .ant-table-filter-dropdown {
        width: 220px;
    }

    .ant-table-filter-dropdown .ant-dropdown-menu-title-content {
        white-space: normal;
        overflow-wrap: anywhere; /* breaks super long tokens */
        word-break: break-word;
    }

    /* Search input */
    .ant-table-filter-dropdown .ant-table-filter-dropdown-search .ant-input,
    .ant-table-filter-dropdown .ant-table-filter-dropdown-search .ant-input-affix-wrapper,
    .ant-table-filter-dropdown .ant-table-filter-dropdown-search .ant-input-affix-wrapper > input.ant-input {
        border-radius: 8px;
        color: ${TEXT_COLORS.filled};
        ${FONT_FAMILY.poppins};
    }

    /* placeholder */
    .ant-table-filter-dropdown .ant-table-filter-dropdown-search .ant-input::placeholder,
    .ant-table-filter-dropdown
        .ant-table-filter-dropdown-search
        .ant-input-affix-wrapper
        > input.ant-input::placeholder {
        color: ${TEXT_COLORS.body};
    }

    /* hide default empty state icon */
    .ant-table-filter-dropdown .ant-empty-image {
        display: none !important;
    }

    /* Scroll area (menu mode) */
    .ant-table-filter-dropdown .ant-dropdown-menu {
        ${DEFAULT_SCROLL_STYLING_FOR_FILTERS}
    }

    /* Scroll area (tree mode) */
    .ant-table-filter-dropdown .ant-table-filter-dropdown-tree {
        ${DEFAULT_SCROLL_STYLING_FOR_FILTERS}
    }

    /* Webkit scrollbar */
    .ant-table-filter-dropdown .ant-dropdown-menu::-webkit-scrollbar,
    .ant-table-filter-dropdown .ant-table-filter-dropdown-tree::-webkit-scrollbar {
        width: 6px;
    }

    .ant-table-filter-dropdown .ant-dropdown-menu::-webkit-scrollbar-thumb,
    .ant-table-filter-dropdown .ant-table-filter-dropdown-tree::-webkit-scrollbar-thumb {
        background: ${BORDER_COLORS.focus};
        border-radius: 999px;
    }

    /* Buttons row (OK / Reset) */
    .ant-table-filter-dropdown .ant-table-filter-dropdown-btns {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        ${BODY_MD_MD_STYLES};
    }
`;

export const SearchInputWrapper = styled.div`
    margin-bottom: var(--spacing-sm, 16px);

    .ant-input-affix-wrapper {
        width: 300px;
        height: 40px;
        padding: 0 10px;

        .ant-input {
            color: ${TEXT_COLORS.filled};
            ${BODY_SM_SM_STYLES};
            font-size: 14px !important;
        }
        .ant-input::placeholder {
            color: ${TEXT_COLORS.disabled};
        }
    }
`;

export const LearningDashboardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
